/* eslint-disable @typescript-eslint/tslint/config */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-const */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import { useStaticQuery, graphql } from "gatsby";

const Outbound = styled(OutboundLink)`
  display: block;
  color: unset;
  text-decoration: underline;
`;

const InBound = styled(GatsbyLink)`
  display: block;
  color: unset;
  text-decoration: underline;
`;

const Link: React.FC<Props> = ({ children, to, name, target, ...props }) => {
  const url = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          url
        }
      }
    }
  `).site.siteMetadata.url;

  if (!to) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return <a {...props}>{children}</a>;
  }
  // eslint-disable-next-line @typescript-eslint/tslint/config
  let a = to.toLowerCase();
  if (a.startsWith(url)) {
    // eslint-disable-next-line no-param-reassign
    a = to.toLowerCase().replace(url, "");
  }
  if (a.startsWith("#")) {
    return (
      <a
        aria-label={name || "scroll to " + a.replace("#", "") + " section"}
        href={a}
        {...props}
      >
        {children}
      </a>
    );
  }
  if (a.startsWith("mailto")) {
    return (
      <Outbound aria-label={name || "Send a email to " + a.replace('mailto:', "").split("?")[0]} href={a} title="Open email client" {...props} target={target || "_blank"}>
        {children}
      </Outbound>
    );
  }
  if (a.startsWith("http") || a.startsWith("www")) {
    const url = new URL(a);
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      <Outbound aria-label={url ? "outbound link to " + url.hostname : "outbound link"} title={url ? "outbound link to " + url.hostname : "outbound link"} rel="noreferrer" href={a} {...props} target={target || "_blank"}>
        {children}
      </Outbound>
    );
  } else {
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      <InBound aria-label={name || to} title={a} to={a} target={target} {...props}>
        {children}
      </InBound>
    );
  }
};

export { Link };

export interface Props {
  children: unknown;
  props?: unknown;
  to?: string;
  hover?: string;
  name?: string;
  target?: string;
  block?: unknown;
}
